import { useState } from "react";
import { createPortal } from "react-dom";
import "./CoConnectHub.css";
import "./ExploreResultsHub.css";
import ExploreRelationships, {
  EXPLORE_RELATIONSHIPS_READY,
} from "./ExploreRelationships.js";
import ExploreHealth from "./ExploreHealth.js";

const reportCards = [
  {
    title: "Assessments",
    description: "Review your completed Wholistic Health Assessments.",
    icon: "/Icon-WHA-Blue.png",
    view: "AssessmentReport",
    action: "View Assessments",
  },
  {
    title: "Health Plans",
    description: "Review your current health plan actions and progress.",
    icon: "/Icon-CP-Blue.png",
    view: "HealthPlanReport",
    action: "View Health Plans",
  },
  {
    title: "Lab Results",
    description: "Review your current lab results and reference ranges.",
    icon: "/Icon-Lab-Blue.png",
    view: "LabResultsReport",
    action: "View Lab Results",
  },
  {
    title: "Compare Assessments/Labs",
    description: "Compare completed assessments or lab results over time.",
    icon: "/Icon-TP-Blue.png",
    view: "CompareReports",
    action: "Compare Results",
  },
];

export default function ExploreResultsHub({ setCurrentView, sidebarOpen }) {
  const [showExploreRelationships, setShowExploreRelationships] =
    useState(false);
  const [showExploreHealth, setShowExploreHealth] = useState(false);
  return (
    <div className="cch-container">
      <img
        src={(process.env.PUBLIC_URL || "") + "/Icon-RS-Blue.png"}
        alt="Logo"
        className="explore-results-logo"
      />
      <h1 className="cch-title">Explore Results and Reports</h1>
      <p className="cch-subtitle">
        Explore your assessment, health plan, and lab results.
      </p>

      <div className="cch-pillars explore-results-pillars">
        <div className="cch-card" onClick={() => setShowExploreHealth(true)}>
          <img
            className="cch-card-icon"
            src={(process.env.PUBLIC_URL || "") + "/Icon-WHP-Blue.png"}
            alt="Explore Your Whole Health icon"
          />
          <h2 className="cch-card-title">Explore Your Whole Health</h2>
          <p className="cch-card-text">
            Discover the patterns, strengths, and next steps within your
            assessment results.
          </p>
          <button
            type="button"
            className="cch-button"
            onClick={() => setShowExploreHealth(true)}
          >
            Explore My Results
          </button>
        </div>

        {reportCards.map(({ title, description, icon, view, action }) => (
          <div
            className="cch-card"
            key={view}
            onClick={() => setCurrentView(view)}
          >
            <img
              className="cch-card-icon"
              src={(process.env.PUBLIC_URL || "") + icon}
              alt={`${title} icon`}
            />
            <h2 className="cch-card-title">{title}</h2>
            <p className="cch-card-text">{description}</p>
            <button className="cch-button">{action}</button>
          </div>
        ))}

        <div
          className="cch-card"
          onClick={() => setShowExploreRelationships(true)}
        >
          <img
            className="cch-card-icon"
            src={(process.env.PUBLIC_URL || "") + "/Icon-RS-Blue.png"}
            alt="Explore Relationships icon"
          />
          <h2 className="cch-card-title">Explore Relationships</h2>
          <p className="cch-card-text">
            See insights regarding how health outcomes statistically affect
            other outcomes.
          </p>
          <button className="cch-button">Explore</button>
        </div>
      </div>

      {showExploreHealth &&
        createPortal(
          <div
            className="explore-results-overlay"
            style={{ left: sidebarOpen ? 280 : 0 }}
            onClick={() => setShowExploreHealth(false)}
          >
            <div
              className="explore-results-popup explore-results-popup--live"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="explore-results-popup-header">
                <h2>Explore Your Wholistic Health</h2>
                <button
                  className="cch-button"
                  onClick={() => setShowExploreHealth(false)}
                >
                  Close
                </button>
              </div>
              <ExploreHealth
                onAddToPlan={() => {
                  setShowExploreHealth(false);
                  setCurrentView("CreatePlan");
                }}
                onTrackHabit={() => {
                  setShowExploreHealth(false);
                  setCurrentView("TrackProgress");
                }}
              />
            </div>
          </div>,
          document.body,
        )}

      {showExploreRelationships &&
        createPortal(
          <div
            className="explore-results-overlay"
            style={{ left: sidebarOpen ? 280 : 0 }}
            onClick={() => setShowExploreRelationships(false)}
          >
            <div
              className={`explore-results-popup${
                EXPLORE_RELATIONSHIPS_READY
                  ? " explore-results-popup--live"
                  : ""
              }`}
              onClick={(event) => event.stopPropagation()}
            >
              {EXPLORE_RELATIONSHIPS_READY ? (
                <>
                  <div className="explore-results-popup-header">
                    <h2>Relationship Explorer</h2>
                    <button
                      className="cch-button"
                      onClick={() => setShowExploreRelationships(false)}
                    >
                      Close
                    </button>
                  </div>
                  <ExploreRelationships />
                </>
              ) : (
                <>
                  <h2>Relationship Explorer</h2>
                  <p>This feature will be available soon.</p>
                  <div className="explore-results-planned-features">
                    <strong>Planned Features</strong>
                    <ul>
                      <li>Advanced statistical relationship mapping</li>
                      <li>Interactive health outcome exploration</li>
                      <li>Demographic filtering and trend analysis</li>
                      <li>Visual correlation and pattern discovery</li>
                    </ul>
                  </div>
                </>
              )}
              {!EXPLORE_RELATIONSHIPS_READY && (
                <button
                  className="cch-button"
                  onClick={() => setShowExploreRelationships(false)}
                >
                  Close
                </button>
              )}
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
}
